export default "__VITE_ASSET__CXV3i$mM__"